(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  // Scope nur auf Kollektion-FAQ-Section
  var wrap = document.querySelector('.madeit-collection-faqs-acc-grid');
  if (!wrap) return;
  var animate = wrap.getAttribute('data-animate') === 'true';
  if (!animate) return;

  function setMaxHeight(detailsEl){
    var panel = detailsEl.querySelector('.madeit-collection-faqs-acc-panel');
    if (!panel) return;
    panel.style.maxHeight = detailsEl.open ? (panel.scrollHeight + 'px') : '0px';
  }

  wrap.querySelectorAll('.madeit-collection-faqs-acc').forEach(function(det){
    var panel = det.querySelector('.madeit-collection-faqs-acc-panel');
    if (!panel) return;
    if (det.open) panel.style.maxHeight = panel.scrollHeight + 'px';
    det.addEventListener('toggle', function(){ setMaxHeight(det); });

    var ro = new ResizeObserver(function(){
      if (det.open) setMaxHeight(det);
    });
    ro.observe(panel);
  });

  window.addEventListener('resize', function(){
    wrap.querySelectorAll('.madeit-collection-faqs-acc[open] .madeit-collection-faqs-acc-panel').forEach(function(panel){
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
